import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default  new Vuex.Store({
    state:{      
      resultado:[],
      mostrarCalculoAgregado: false,
      tipoDeAnalise:'NORMAL',
      entrada:{
        tipoDocumento:0,
        cnpj:'',
        regimeTributario:0,
        idCliente:''
      }
    },   
  })